// removed by extract-text-webpack-plugin
module.exports = {"section":"_3A6W7bZM","title":"_36DHvT0U","content":"_31mo87yM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Section/Section.pcss
// module id = 782
// module chunks = 0